import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getOptedCampaignsDetailsByInfluencerSuccess } from '../../actions/InfluencerCampaignActions/getOptedCampaignsDetailsByInfluencerActions';
import { getOptedCampaignsDetailsByInfluencerFailure } from '../../actions/InfluencerCampaignActions/getOptedCampaignsDetailsByInfluencerActions';

function* getOptedCampaignsDetailsByInfluencer({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getOptedCampaignsDetailsByInfluencer + '?campaignId=' + payload.campaignId,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_SUCCESS status :", response.data.status);
        console.log("GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_SUCCESS data :", response.data.response);
        console.log("GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getOptedCampaignsDetailsByInfluencerSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_FAILURE status :", error?.response?.status);
        console.log("GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_FAILURE data:", error?.response?.data);
        console.log("GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_FAILURE error :", error);
        console.log('====================================');
        yield put(getOptedCampaignsDetailsByInfluencerFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getOptedCampaignsDetailsByInfluencerSaga() {
    yield takeLatest(actionTypes.GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_REQUEST, getOptedCampaignsDetailsByInfluencer);
}

export default getOptedCampaignsDetailsByInfluencerSaga;
